import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { LogoWhite } from './Logo';
import LanguageSelector from './LanguageSelector';
import './Navbar.css';

const Navbar = () => {
  const { t } = useTranslation();
  const { isAuthenticated, logout, instructor, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const accessRole = (instructor?.accessRole || '').toLowerCase();
  const isPartner = isAuthenticated && accessRole === 'partner';

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/');
  };

  const closeMenu = () => setMenuOpen(false);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const registrationMenu = (
    <div className="nav-register-wrap">
      <button type="button" className="nav-register-trigger" aria-haspopup="true">
        {t('nav.registration')}
      </button>
      <div className="nav-register-dropdown">
        <Link to="/owner/register" onClick={closeMenu}>{t('nav.registerOwner')}</Link>
        <Link to="/pilot/register" onClick={closeMenu}>{t('nav.registerPilot')}</Link>
        <Link to="/booking" onClick={closeMenu}>{t('nav.registerPassenger')}</Link>
      </div>
    </div>
  );

  const partnerNavLinks = (
    <>
      <Link to="/partner/dashboard" onClick={closeMenu} className="nav-logo-link">
        <div className="nav-logo-frame">
          <LogoWhite className="nav-logo" />
        </div>
      </Link>
      <Link to="/partner/dashboard" onClick={closeMenu}>{t('nav.partnerArea')}</Link>
      <span className="nav-user">{t('nav.hi', { name: instructor?.name })}</span>
      <button onClick={handleLogout} className="btn btn-secondary">
        {t('nav.logout')}
      </button>
      <div className="nav-lang-wrap">
        <LanguageSelector />
      </div>
    </>
  );

  const navLinks = isPartner ? partnerNavLinks : (
    <>
      <Link to="/" onClick={closeMenu} className="nav-logo-link">
        <div className="nav-logo-frame">
          <LogoWhite className="nav-logo" />
        </div>
      </Link>
      <Link to="/" onClick={closeMenu}>{t('nav.home')}</Link>
      <Link to="/gallery" onClick={closeMenu}>{t('nav.gallery')}</Link>
      <Link to="/easa-charter" onClick={closeMenu}>EASA Charter</Link>
      {isAuthenticated && (
        <Link to="/safety-forum" onClick={closeMenu}>{t('nav.safetyForum')}</Link>
      )}
      {registrationMenu}
      {authLoading ? (
        <span className="nav-auth-loading" aria-busy="true" />
      ) : isAuthenticated ? (
        <>
          {accessRole === 'owner' ? (
            <Link to="/owner/dashboard" onClick={closeMenu}>{t('nav.ownerArea')}</Link>
          ) : (
            <Link to="/admin" onClick={closeMenu}>{t('nav.admin')}</Link>
          )}
          <span className="nav-user">{t('nav.hi', { name: instructor?.name })}</span>
          <button onClick={handleLogout} className="btn btn-secondary">
            {t('nav.logout')}
          </button>
        </>
      ) : (
        <Link to="/admin/login" onClick={closeMenu}>{t('nav.userLogin')}</Link>
      )}
      <div className="nav-lang-wrap">
        <LanguageSelector />
      </div>
    </>
  );

  return (
    <>
      {/* Asztali sáv – széles képernyőn */}
      <header className="navbar-desktop" aria-label={t('nav.mainMenu')}>
        <nav className="navbar-desktop-inner">
          {navLinks}
        </nav>
      </header>

      {/* Hamburger – csak mobilon */}
      <div className="nav-hamburger-wrap" aria-hidden="true">
        <button
          type="button"
          className="nav-toggle"
          aria-label={menuOpen ? t('nav.closeMenu') : t('nav.openMenu')}
          aria-expanded={menuOpen}
          onClick={toggleMenu}
        >
          <span className="nav-toggle-bar" />
          <span className="nav-toggle-bar" />
          <span className="nav-toggle-bar" />
        </button>
      </div>

      {/* Mobil oldalmenü */}
      <div className={`nav-links ${menuOpen ? 'nav-links-open' : ''}`} role="dialog" aria-modal="true" aria-label={t('nav.navigation')}>
        {navLinks}
      </div>

      {menuOpen && (
        <div
          className="nav-overlay"
          aria-hidden="true"
          onClick={closeMenu}
        />
      )}
    </>
  );
};

export default Navbar;
